import { BadgeDesignTokens } from '@primeng/themes/types/badge';

export const baseBadgeToken: BadgeDesignTokens = {
  colorScheme: {
    light: {
      danger: {
        background: '{red.300}',
      },
    },
  },
};
